import moment from 'moment'

// Ordem de prioridade das incapacidades, da menos para a mais importante —
// mesma ordem usada no motor novo (CalculoPeriodosIncapacidades.cs), ao
// contrário da lista usada no cálculo antigo do cm-api (disabilitiesPriorities
// em computeDisabilityByDays.ts), que tem uma ordem diferente e não inclui MSA.
const disabilitiesPriorities = [
	'ADM',
	'AAT',
	'MSA',
	'MIA',
	'ACSD',
	'APD',
	'AINC',
	'ACCD',
	'SI',
	'ITP',
	'ITA',
]

const priorityOf = (disabilityId) =>
	disabilitiesPriorities.findIndex((item) => item === disabilityId)

const winsOver = (candidate, current) => {
	if (!current) return true
	if (candidate.rate !== current.rate) return candidate.rate > current.rate
	return priorityOf(candidate.disabilityId) > priorityOf(current.disabilityId)
}

// Calcula, dia a dia, qual é a incapacidade mais forte entre TODAS as
// especialidades do processo (independente da especialidade), e devolve os
// valores distintos (taxa + tipo) com a contagem total de dias de cada um.
// Feito de raiz para o motor novo — não reaproveita computeDisabilityByDays.ts
// do cm-api, que tem um bug conhecido com períodos de datas invertidas.
export const computeDisabilityDaysSummaryNewEngine = (periods) => {
	const byDay = {}
	const order = []

	;(periods ?? []).forEach((period) => {
		if (!period.startDate) return

		const start = moment(period.startDate).startOf('day')
		const end = period.endDate
			? moment(period.endDate).startOf('day')
			: start.clone()

		if (end.isBefore(start)) return

		const candidate = {
			rate: period.rate,
			disabilityId: period.disabilityId,
		}

		let current = start.clone()
		while (current.isSameOrBefore(end, 'day')) {
			const day = current.format('YYYY-MM-DD')

			if (winsOver(candidate, byDay[day])) {
				byDay[day] = candidate
			}

			current = current.add(1, 'day')
		}
	})

	Object.keys(byDay)
		.sort((a, b) => moment(a).valueOf() - moment(b).valueOf())
		.forEach((day) => {
			const value = byDay[day]
			const key = `${value.rate}-${value.disabilityId}`
			if (!order.includes(key)) order.push(key)
		})

	const counts = {}
	Object.values(byDay).forEach(({ rate, disabilityId }) => {
		const key = `${rate}-${disabilityId}`
		counts[key] = (counts[key] || 0) + 1
	})

	return order.map((key) => {
		const [rate, disabilityId] = key.split('-')
		return { rate: Number(rate), disabilityId, count: counts[key] }
	})
}
